import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const RavenSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default RavenSVG;
